import React from 'react'
import { Box } from '../../Components/Layout'
import { InnerCon } from './styles'
import { Lk } from '../../Components/Links/Lk'
import { PLL_LINKS } from '../../Config/config'

export const Explainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Box noMargin>
      <InnerCon>
        <Lk link={PLL_LINKS.rules} alt="League Official Rules">League Official Rules</Lk>
        <h2>Roster Designations:</h2>
        <ul>
          <li>
            <strong>Injured List:</strong> Unable to perform due to a lacrosse-related
            injury or ailment sustained during the season.
          </li>
          <li>
            <strong>Unavailable to Travel List:</strong> A Player who has an approved
            excused absence and cannot make the start of the PLL Season. A player on the
            Unavailable to Travel List does not count against the Club's roster limits.
            Once a player is removed from the Unavailable to travel list, he must be
            placed on the clubs active reserve, or inactive roster immediately, or be
            released into the player pool.
          </li>
          <li>
            <strong>PUP List:</strong> Physically Unable to Perform due to injury outside
            of a PLL game.
          </li>
          <li>
            <strong>Holdout List:</strong> Player who fails to report to his club, has
            not been medically cleared, or fails to submit paperwork will be placed on
            the holdout list.
          </li>
          <li>
            <strong>Military Reserve List:</strong> For active duty or training military
            personnel.
          </li>
          <li>
            <strong>Player Pool:</strong> Players signed to the PLL who are not currently
            on an active roster.
          </li>
        </ul>

        <h2>Trade Window</h2>
        <ul>
          <li>
            <strong>(i)</strong>{' '}
            {`Off-Season Trade Window:  Begins March 3, 2025, at 9:00 AM (ET) and closes on Friday, May 9, 2025, at 2:00 PM (ET). Clubs may trade signed Players during this window.`}
          </li>
          <li>
            <strong>(ii)</strong>{' '}
            {`Regular Season Trade Window:  Trades may occur beginning immediately following the completion of Regular Season Week 1 at 9:00 AM (ET) and continue through the Tuesday prior to the final event weekend of the Regular Season, closing at 2:00 PM (ET), unless otherwise notified by the League in advance.`}
          </li>
        </ul>

        <h2>Player Movement and other Player Transactions</h2>
        <ul>
          <li>{`“Player Movement” refers to the status afforded to Players who are eligible to negotiate a contract with any Club. Players will become eligible for Player Movement:`}</li>
          <ul>
            <li>
              <strong>(a)</strong>{' '}
              {`when Player’s existing contract expires; or`}
            </li>
            <li>
              <strong>(b)</strong>{' '}
              {` if Player is not on his Club’s Active Roster for 30% or more of “eligible” games in a Season. The Player must remain with his Club for more than 50% of the Season, but such Player will become eligible for Player Movement beginning in the off-season immediately following.`}
            </li>
          </ul>
          <li>{`If a Player is on the Injured List, Holdout List, Family or Medical Leave List, or is otherwise listed under any of the designations under Section 11.04 for any game, the Player is not considered “eligible” to play for that game, and such game will not count against the Club’s 30% threshold.`}</li>
          <li>{`Any college graduate who is not drafted in the College Draft may be signed by a Club as a “College Eligible Players” at any point in the year in which such player graduated college. Clubs are not permitted to claim a College Eligible Player until after the College Draft. All College Eligible Players will go through the waiver process for the first waiver period following the college draft. Following that, all College Eligible Players become eligible for Player Movement and are able to sign with any Club, regardless of waiver priority.`}</li>
          <li>{`Other Transactions.  If a Player is not protected on a Club’s Reserve Roster for three (3) consecutive games, he will be eligible to transact with another Club via the waiver process. If a Club wishes to pick up the Player, his contract will be assigned to the receiving Club and the Player must be immediately placed on the Club’s Active Roster.  If not picked up by another Club, the Player will remain on his current Club’s Roster.`}</li>
          <li>{`Player Pool Claims: During the Regular Season, Player Pool claims are submitted each Monday. Players that are claimed or signed by a Club are immediately eligible to be placed on a Club’s Active Roster, provided they execute an SPA.`}</li>
          <li>{`Players may be released at any time.  Any Player who is released, will be eligible for waiver claims according to waiver priority. For any Player who is released, the following Waiver Claims process will take place:`}</li>
          <ol>
            <li>
              <strong>1.</strong>{` `}
              {`Player will go through the waiver process. Clubs in order of the League’s waiver priority will have the opportunity to pick up the Player at his existing contract terms. If a Club elects to pick up the Player in the waiver process, Player’s SPA will be assigned to that Club.`}
            </li>
            <li>
              <strong>2.</strong>{` `}
              {`If the Player clears waivers without being claimed by any Club, his contract will automatically terminate, and the Player will join the Player Pool.`}
            </li>
            <li>
              <strong>3.</strong>{` `}
              {`The Player will then be designated to the Player Pool and be available for Player Movement`}
            </li>
          </ol>
        </ul>

        <h2>Waiver Periods</h2>
        <ul>
          <li>
            {`Waivers will run throughout the offseason player movement period on each Tuesday and Friday during that time.`}
          </li>
          <li>
            {`The Special College Free Agent Waiver period will run on Thursday, May 8th. This waiver period will only include College Eligible players.`}
          </li>
          <li>
            {`The Special Training Camp Designee Waiver Period will run on Monday, May 19th. Team will be permitted to add players up to their modified roster limits once players moved to the unavailable to travel list or other roster tags have been established.`}
          </li>
          <li>{`Regular Season Waivers will run the Monday and Tuesday of each week.`}</li>
        </ul>
      </InnerCon>
    </Box>
  )
}
